// @flow
import React, { useEffect, useState } from 'react';
// Components
import ProgressionBar from '../../current-order/components/ProgressionBar';
// helpers
import { priceConverter } from '../../common';
// Styles
import './FreeShippingNotice.css';

type Props = {
  currentPrice: number,
};

const FreeShippingNotice = ({ currentPrice }: Props) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="free-shipping-notice-main">
      {currentPrice >= 150 ? (
        <span className="free-shipping-notice-text">
          <span className="free-shipping-notice-main-green">Frete grátis disponível </span>{' '}
          para essa compra!
        </span>
      ) : (
        <span className="free-shipping-notice-text">
          Adicione <span className="free-shipping-notice-main-green">{priceConverter(150 - currentPrice)}</span>  para{' '} garantir o 
          <span className="free-shipping-notice-main-green"> Frete Grátis</span>
        </span>
      )}

      {windowWidth > 740 && (
        <ProgressionBar
          absoluteValueToCompare={150}
          valueToBeCompared={currentPrice}
          barColor="#1C8E47"
          backgroundbarColor="#BEDDCA"
        />
      )}
    </div>
  );
};

export default FreeShippingNotice;
